import React from 'react';

import './style.css';
import Switch from '../Switch';
import { isMobile } from '../../helpers/utils';

const Accordion = props => {
    const { header, enabled, callback } = props;
    const converted_header=header.toLowerCase();
    return (      
        <div className="accordion-main">            
            <div className={isMobile() ? `mobile-alert-category-content-account-block` : `alert-category-content-account-block`} >
                <div className="account-block-name-details">
                    <h3>{ converted_header }</h3>
                </div>
                <div className="account-block-switch">
                    <Switch 
                        readValue={converted_header}
                        enabled={enabled || false}
                        onClick = {
                            () => callback(enabled)
                        }
                        isVerified={true}
                    />
                </div>
            </div>
            {   (enabled || false) &&
                props.children
            }
        </div>       
    )
};

export default Accordion;
